// Module
var code = "<molecule-form-edit save=\"$editFormOrganism.save\"> <molecule-panel-error error-type=\"update\" error-box-type=\"fixed\"></molecule-panel-error> <organ-edit-panel-bundle-backups panel-right=\"$editFormOrganism.userPanelRight.users\" service=\"$editFormOrganism.service\"></organ-edit-panel-bundle-backups> </molecule-form-edit> ";
// Exports
module.exports = code;